// src/features/holidays/queries/useHolidaysQuery.ts
import { useQuery } from "@tanstack/react-query";
import axios from "axios";

interface HolidayResponse {
  response: {
    body: {
      items: {
        item: Array<{
          dateKind: string;
          dateName: string;
          locdate: string;
          seq: number;
        }>;
      };
    };
  };
}

const fetchKoreanHolidays = async (year: number): Promise<string[]> => {
  const API_KEY = process.env.REACT_APP_KOREAN_HOLIDAYS_API_KEY;

  if (!API_KEY) {
    throw new Error("API Key가 설정되지 않았습니다");
  }

  const response = await axios.get<HolidayResponse>(
    "https://apis.data.go.kr/B090041/openapi/service/SpcdeInfoService/getRestDeInfo",
    {
      params: {
        serviceKey: API_KEY,
        solYear: year,
        _type: "json",
        numOfRows: 50,
      },
    },
  );

  const holidays = response.data.response.body.items?.item || [];
  return holidays.map((holiday) => holiday.locdate.toString());
};

export const useHolidaysQuery = (year: number) => {
  return useQuery({
    queryKey: ["holidays", year],
    queryFn: () => fetchKoreanHolidays(year),
    staleTime: 1000 * 60 * 60 * 24,
    gcTime: 1000 * 60 * 60 * 24 * 7,
    enabled: !!year,
  });
};
